"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherRewardToJSON = exports.VoucherRewardFromJSONTyped = exports.VoucherRewardFromJSON = exports.instanceOfVoucherReward = void 0;
/**
 * Check if a given object implements the VoucherReward interface.
 */
function instanceOfVoucherReward(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "imageUrl" in value;
    return isInstance;
}
exports.instanceOfVoucherReward = instanceOfVoucherReward;
function VoucherRewardFromJSON(json) {
    return VoucherRewardFromJSONTyped(json, false);
}
exports.VoucherRewardFromJSON = VoucherRewardFromJSON;
function VoucherRewardFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'imageUrl': json['imageUrl'],
    };
}
exports.VoucherRewardFromJSONTyped = VoucherRewardFromJSONTyped;
function VoucherRewardToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'imageUrl': value.imageUrl,
    };
}
exports.VoucherRewardToJSON = VoucherRewardToJSON;
